export const COMPANY = {
  name: 'FATT Elevadores',
  phone: '(17) 99650-4248',
  telephone: 'tel:+5517996504248',
  whatsapp: 'https://wa.me/5517996504248',
  email: 'contato@fattelevadores.com.br',
  address: 'Rua Santa Fé do Sul, 3041 – Eldorado',
  city: 'São José do Rio Preto, SP',
  instagram: 'https://www.instagram.com/fattelevadores/',
  website: 'https://www.fattelevadores.com',
  cnpj: '22.472.731/0001-72',
};

export const whatsappLink = (subject = 'soluções em transporte vertical') =>
  `${COMPANY.whatsapp}?text=${encodeURIComponent(`Olá, FATT Elevadores! Gostaria de conversar sobre ${subject} e solicitar um orçamento.`)}`;

export const navigation = [
  { id: 'home', label: 'Início' },
  { id: 'about', label: 'Sobre' },
  { id: 'solutions', label: 'Soluções' },
  { id: 'services', label: 'Serviços' },
  { id: 'contact', label: 'Contato' },
];

export const solutions = [
  {
    id: 'eletricos', number: '01', title: 'Elevadores elétricos', category: 'RESIDENCIAL E COMERCIAL',
    image: '/images/hero-lobby.webp', alt: 'Elevadores de inox em um hall contemporâneo',
    description: 'Tecnologia que conecta os andares e valoriza o seu espaço. Soluções para residências e edifícios comerciais, com design moderno e personalizado.',
    benefits: ['Eficiência em cada percurso', 'Conforto e segurança no transporte', 'Design adequado ao seu projeto'],
  },
  {
    id: 'hidraulicos', number: '02', title: 'Elevadores hidráulicos', category: 'VERSATILIDADE PARA SEU ESPAÇO',
    image: '/images/panoramic.webp', alt: 'Elevadores panorâmicos de vidro em edifício',
    description: 'Uma solução versátil para coberturas duplex e triplex, sobrados e prédios comerciais. Design e eficiência energética pensados para cada necessidade.',
    benefits: ['Aplicações residenciais e comerciais', 'Integração com a arquitetura', 'Dimensionamento conforme o projeto'],
  },
  {
    id: 'acessibilidade', number: '03', title: 'Plataformas de acessibilidade', category: 'MAIS AUTONOMIA, MENOS BARREIRAS',
    image: '/images/accessibility.webp', alt: 'Plataforma de acessibilidade com proteção de vidro e cadeira de rodas',
    description: 'Acesso com praticidade para pessoas com mobilidade reduzida. Plataformas para ambientes residenciais e comerciais, internos ou externos.',
    benefits: ['Soluções para espaços reduzidos', 'Mobilidade com segurança', 'Praticidade no dia a dia'],
  },
  {
    id: 'maca-leito', number: '04', title: 'Elevadores de maca e leito', category: 'CUIDADO EM CADA DESLOCAMENTO',
    image: '/images/hospital.webp', alt: 'Elevador hospitalar amplo em inox com uma maca',
    description: 'Transporte vertical para hospitais, clínicas e consultórios. Robustez e durabilidade para acompanhar a rotina de quem cuida de pessoas.',
    benefits: ['Capacidade e dimensões especiais', 'Espaço para macas e leitos', 'Projetados para a rotina hospitalar'],
  },
  {
    id: 'carga', number: '05', title: 'Elevadores de carga', category: 'EFICIÊNCIA QUE MOVE SEU NEGÓCIO',
    image: '/images/freight.webp', alt: 'Elevador de carga com cabine metálica e piso reforçado',
    description: 'Soluções para o transporte de materiais em diversos segmentos. Capacidades de 50 a 1000 kg, conforme as necessidades e especificações de cada projeto.',
    benefits: ['Capacidade definida sob medida', 'Operação simples e segura', 'Agilidade na movimentação de cargas'],
  },
  {
    id: 'manutencao', number: '06', title: 'Manutenção e reforma', category: 'SEU ELEVADOR, SEMPRE EM EVOLUÇÃO',
    image: '/images/maintenance.webp', alt: 'Técnico trabalhando em painel elétrico',
    description: 'Manutenção preventiva e corretiva em todas as marcas e modelos. Modernização e embelezamento de cabinas com atenção a cada detalhe.',
    benefits: ['Técnicos treinados e qualificados', 'Cuidado para ampliar a vida útil', 'Renovação e excelência no acabamento'],
  },
  {
    id: 'estrutura-metalica', number: '07', title: 'Estrutura metálica', category: 'SOB MEDIDA PARA SEU PROJETO',
    image: '/images/solutions-generated/estrutura-metalica-1.webp', alt: 'Torre externa de metal e vidro junto a uma residência amarela',
    keepPreviousImage: false,
    description: 'Estruturas metálicas sob medida para elevadores e plataformas de até 5 paradas. Para residências, comércios e condomínios, com estrutura robusta e design moderno.',
    benefits: [
      'Pintura eletrostática preta, branca ou natural; outras cores sob consulta',
      'Revestimento em vidro laminado incolor 5+5, considerando 3 faces conforme projeto',
      'Fabricação própria e instalação pela FATT',
      'ART registrada no CREA',
    ],
  },
];